import Axios from '../config/axios';
import { UrlConstant } from '../commom/UrlConstant';

export async function getInternationalWireInstructions() {
  try {
    const resp = await Axios.get(UrlConstant.Crypto.GetInternationalWireInstructions);
    if (resp?.data?.success) {
      return resp.data.data;
    }
    return null;
  } catch (err: any) {
    console.error('Error fetching international wire instructions:', err?.response?.data || err.message);
    return null;
  }
}

export async function getCryptoLoan() {
  try {
    const resp = await Axios.get(UrlConstant.Crypto.GetCryptoLoan);
    if (resp?.data) {
      return resp.data.data ?? null;
    }
    return null;
  } catch (err: any) {
    console.error('Error fetching crypto loan data:', err?.response?.data || err.message);
    return null;
  }
}
